import { createGraphQLClient, createQueryClient } from '@edreamsodigeo/frontend-api-client';
import schema from '@edreamsodigeo/frontend-graphql-contract';
export const createFrontendAPIClientProps = ({
  logger,
  tokenFallback
}) => ({
  queryClient: createQueryClient(),
  graphQLClient: createGraphQLClient(),
  schema,
  logger,
  tokenFallback
});